import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../axios/axiosInstance";

export const fetchDevices = createAsyncThunk(
  "devices/fetchDevices",
  async (_, { rejectWithValue }) => {
    try {
        console.log("fetching devices");
        
      const response = await api.get("superAdmin/getAllPBXDevices");

      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const addDevice = createAsyncThunk(
  "devices/addDevice",
  async (deviceData, { rejectWithValue }) => {
    try {
      console.log(deviceData, "add device payload");

      const response = await api.post("/superAdmin/addPBXDevice", deviceData);
      console.log(response.data, "response from add device");

      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const updateDevice = createAsyncThunk(
  "devices/updateDevice",
  async (devicePayload, { rejectWithValue }) => {
    try {
      console.log(devicePayload,"devicePayload");

      const response = await api.put(
        `/superAdmin/updatePBXDevice`,
        devicePayload,
      );
      console.log(response.data.updatedDevice, "response from upadte device");

      return response.data.updatedDevice;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const deleteDevice = createAsyncThunk(
  "devices/deleteDevice",
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.delete(`superAdmin/deletePBXDevice`, {
        data: { deviceId: id },
      });

      console.log(response.data, "hjgfdfxchvjbk");

      return id;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

const devicesSlice = createSlice({
  name: "devices",
  initialState: {
    devices: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      /* FETCH */
      .addCase(fetchDevices.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDevices.fulfilled, (state, action) => {
        state.loading = false;
        state.devices = action.payload;
      })
      .addCase(fetchDevices.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ADD */
      .addCase(addDevice.pending, (state) => {
        state.loading = true;
      })
      .addCase(addDevice.fulfilled, (state, action) => {
        state.loading = false;
        console.log(action.payload, "bhjgfcdfgchvjb");

        state?.devices?.unshift(action.payload);
      })
      .addCase(addDevice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* UPDATE */
      .addCase(updateDevice.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateDevice.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.devices.findIndex(
          (d) => d.deviceId === action.payload.deviceId,
        );
        if (index !== -1) {
          state.devices[index] = action.payload;
        }
      })

      .addCase(updateDevice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* DELETE */
      .addCase(deleteDevice.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteDevice.fulfilled, (state, action) => {
        state.loading = false;
        state.devices = state.devices.filter(
          (d) => d.deviceId !== action.payload,
        );
      })
      .addCase(deleteDevice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default devicesSlice.reducer;
